var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "#564AB3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 16C24.1435 16 22.363 16.7375 21.0503 18.0503C19.7375 19.363 19 21.1435 19 23C19 24.596 19.784 26.4832 20.9278 28.5076C22.0856 30.5558 23.6816 32.8574 25.4302 35.3074L26 36.1054L26.5698 35.3074C28.3198 32.8574 29.9144 30.5558 31.0722 28.5076C32.216 26.4832 33 24.596 33 23C33 22.0807 32.8189 21.1705 32.4672 20.3212C32.1154 19.4719 31.5998 18.7003 30.9497 18.0503C30.2997 17.4002 29.5281 16.8846 28.6788 16.5328C27.8295 16.1811 26.9193 16 26 16ZM26 19.5C25.0717 19.5 24.1815 19.8687 23.5251 20.5251C22.8687 21.1815 22.5 22.0717 22.5 23C22.5 23.9283 22.8687 24.8185 23.5251 25.4749C24.1815 26.1313 25.0717 26.5 26 26.5C26.9283 26.5 27.8185 26.1313 28.4749 25.4749C29.1313 24.8185 29.5 23.9283 29.5 23C29.5 22.0717 29.1313 21.1815 28.4749 20.5251C27.8185 19.8687 26.9283 19.5 26 19.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.3909c2ba7fec61c2237c0475eb4deee8.svg";
export { ForwardRef as ReactComponent };